const { VUE_APP_PUBLICPATH } = process.env;
__webpack_public_path__ = (window.static_cdn||"")+VUE_APP_PUBLICPATH+'/' // eslint-disable-line
